import React, {useState} from "react";
import QuadralModal from '@quadral/quadral-component-common/dist/components/modal';
import QuadralButton from '@quadral/quadral-component-common/dist/components/button';
import {QuadralLoaderProvider} from '@quadral/quadral-component-common/dist/components/loader/LoaderContext';
import QuadralContainer from "@quadral/quadral-component-common/dist/components/container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPen } from "@fortawesome/free-solid-svg-icons";
import { onlineProcessesService } from "../../../../services";

export default function AICheckModal ({open, setOpen, participation, participationId, participationStatus, updatedStatus, quadralToast, ...props}) {
    const [loader, setLoader] = useState(false);
    const [loading, setLoading] = useState(false);
    const [processing, setProcessing] = useState(false);

    async function startAICheck() {
        if (processing) return;
        try {
            setProcessing(true);
            setLoader(true);
            setLoading(true);
            await(onlineProcessesService.analyzeParticipation(participationId));
            props.setAllVialinkChecked(false);
            quadralToast.success("Tout les documents ayant été fournis vont être vérifiés.");
        } catch (error) {
            quadralToast.error('Aucune fiche personne ayant été soumise n\'a été trouvée');
            console.error(error);
        } finally {
            setLoader(false);
            setLoading(false);
            setProcessing(false);
            setOpen(false)
        }
    }
    
    return (
    <>
        {loading && <QuadralLoaderProvider/>}
        {open && (
            <QuadralModal
                size='XL'
                title={participationStatus === 'en_attente_des_pj' ? 
                    ( <span>Valider l'envoi des pièces justificatives</span> ) : 
                    ( <span>Valider l'envoi des compléments</span> ) }
                icon={<FontAwesomeIcon icon={faUserPen}/>}
                open={open}
                setOpen={setOpen}
                action={<>
                    <QuadralButton 
                        color='error'
                        disabled={processing}
                        onClick={() => {if(!processing) setOpen(false)}}
                    >
                        Annuler
                    </QuadralButton>
                    <QuadralButton
                        color='success'
                        disabled={processing}
                        onClick={() => {if(!processing) startAICheck()}}
                    >
                        Confirmer
                    </QuadralButton>
                </>}
            >
                <QuadralContainer>
                    <span className="text-weight-bold">Vous allez envoyer les documents que vous venez d'ajouter. Ceux-ci seront validés automatiquement.</span>
                    <br/>
                    <p>Le processus peut prends plusieurs minutes, veuillez vous assurer d'avoir ajouté tous les documents à envoyer.</p>
                    <div className="main" style={{display: 'flex', margin: '20px 0 30px 0'}}>
                        {loader && <QuadralLoaderProvider className='loader-custom'/>}
                    </div>
                    {loader && <span style={{display: 'flex', marginBottom:'20px'}}>Veuillez patienter s'il vous plaît. Ne fermez pas la page.</span>}
                </QuadralContainer>
            </QuadralModal>
        )}
    </>
  );
}